import downloader from "@/core/services/DownloaderService";

const install = (app) => {
  app.config.globalProperties.$downloader = downloader;

  app.provide("downloader", downloader);
};

export default { install };
